export default __webpack_public_path__ + "static/media/grid_1__05.247e3451.jpg";